module.exports = __webpack_public_path__ + "static/img/news_63.e36de33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_63.jpg
// module id = ScIv
// module chunks = 2